export default "__VITE_ASSET__DsT$qUy3__"